import $ from 'jquery'
import ScrollMagic from 'scrollmagic'
import { TweenMax, TimelineMax, Linear } from 'gsap'
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'
import { isMobileBreakpoint } from './helpers'

/*
  Configure gsap
*/

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax)

/*
  Image sequence
*/

var obj = { curImg: 0 }

var tween = TweenMax.to(obj, 0.5, {
  curImg: 129,
  roundProps: 'curImg',
  immediateRender: true,
  ease: Linear.easeNone,
  onUpdate: function () {
    $('.limitless-sequence-images img.active').removeClass('active')
    $('.limitless-sequence-images img').eq(obj.curImg).addClass('active')
  },
})

var controller = new ScrollMagic.Controller()

new ScrollMagic.Scene({ triggerElement: '#limitless', duration: 1000 })
  .setTween(tween)
  .addTo(controller)

/*
  Limitless paralax
*/

const limitless = $('.slide-up')

$(window).on('scroll', function (e) {
  const pos = $(window).scrollTop() + $(window).height()
  const sectionPos = limitless.offset().top
  const difference = sectionPos - pos

  if (difference < 0) {
    const transform = `${-difference * 0.3}px`
    limitless.attr('style', `margin-top: ${transform};`)
  }
})

const limitless2 = $('.slide-up-2')

$(window).on('scroll', function (e) {
  const pos = $(window).scrollTop() + $(window).height()
  const sectionPos = limitless2.offset().top
  const difference = sectionPos - pos

  if (difference < 0) {
    const transform = `${-difference * 0.3}px`
    limitless2.attr('style', `margin-top: ${transform};`)
  }
})

/*
 Image swap
*/

// const video = document.querySelector('.limitless-card-nft-video')
// const image = document.querySelector('.limitless-card-nft-image')

// video.addEventListener('timeupdate', function () {
//   if (!isNaN(this.duration)) {
//     var percentComplete = this.currentTime / this.duration

//     // Activate text and scroll at 45%
//     if (percentComplete === 1) {
//       video.classList.add('hide')
//     }
//   }
// })
